export enum VisitorType {
  RapidVisitor = 0,
  PreApproved = 1,
  GateEntry = 2,
  PreVerified = 3,
}
